const root = "LocaleSelector-module_root_Y8pZXPQ0";
const button = "LocaleSelector-module_button_jBHms7No";
const open = "LocaleSelector-module_open_zp0WWTxu";
const buttonContent = "LocaleSelector-module_buttonContent_hhY49BhK";
const label = "LocaleSelector-module_label_NksHnmmx";
const unavailable = "LocaleSelector-module_unavailable_wkU8sIgg";
const arrow = "LocaleSelector-module_arrow_gh6L85jp";
const rotated = "LocaleSelector-module_rotated_2FYWjZFo";
const list = "LocaleSelector-module_list_L63PRT-V";
const listItemWrapper = "LocaleSelector-module_listItemWrapper_eiJfNiUc";
const listItem = "LocaleSelector-module_listItem_P65a900e";
const disabled = "LocaleSelector-module_disabled_BEcCPNF0";
const styles = {
  root,
  button,
  open,
  buttonContent,
  label,
  unavailable,
  arrow,
  rotated,
  list,
  listItemWrapper,
  listItem,
  disabled
};
export {
  arrow,
  button,
  buttonContent,
  styles as default,
  disabled,
  label,
  list,
  listItem,
  listItemWrapper,
  open,
  root,
  rotated,
  unavailable
};
